import { extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import { DO_NOT_USE_FaWrapper } from '../../../v2/foundation/falcon/do-not-use-fa-wrapper/index.js';
import { faCheck } from '@fortawesome/pro-regular-svg-icons/faCheck';
import { faMinus } from '@fortawesome/pro-regular-svg-icons/faMinus';
import { forwardRef, useRef, useEffect } from 'react';
import { useGeneratedId, useForkedRef } from '../../../utils/index.js';
import { FragmentWithoutProps } from '../FragmentWithoutProps/index.js';
import { StyledOverlay } from './styled.js';
import { InputContainer, Input, Label, Container } from '../../styled.js';
import { jsx, jsxs } from 'react/jsx-runtime';

var _jsx2, _jsx3, _jsx4, _jsx5;
var __rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var minusIconMap = new Map([['small', /*#__PURE__*/jsx(DO_NOT_USE_FaWrapper, (_jsx2 = {
  icon: "minus",
  $size: 8
}, _jsx2["icon"] = faMinus, _jsx2))], ['large', /*#__PURE__*/jsx(DO_NOT_USE_FaWrapper, (_jsx3 = {
  icon: "minus",
  $size: 12
}, _jsx3["icon"] = faMinus, _jsx3))]]);
var checkIconMap = new Map([['small', /*#__PURE__*/jsx(DO_NOT_USE_FaWrapper, (_jsx4 = {
  icon: "check",
  $size: 8
}, _jsx4["icon"] = faCheck, _jsx4))], ['large', /*#__PURE__*/jsx(DO_NOT_USE_FaWrapper, (_jsx5 = {
  icon: "check",
  $size: 12
}, _jsx5["icon"] = faCheck, _jsx5))]]);
var Checkbox = /*#__PURE__*/forwardRef(function (props, forwardedRef) {
  var controlledId = props.id,
    _props$invalid = props.invalid,
    invalid = _props$invalid === void 0 ? false : _props$invalid,
    label = props.label,
    _props$indeterminate = props.indeterminate,
    indeterminate = _props$indeterminate === void 0 ? false : _props$indeterminate,
    _props$required = props.required,
    required = _props$required === void 0 ? false : _props$required,
    _props$$size = props.$size,
    $size = _props$$size === void 0 ? 'small' : _props$$size,
    restProps = __rest(props, ["id", "invalid", "label", "indeterminate", "required", "$size"]);
  var autoId = useGeneratedId('textinput');
  var id = controlledId || autoId;
  var inputRef = useRef(undefined);
  var ref = useForkedRef(forwardedRef, inputRef);
  useEffect(function () {
    if (inputRef.current && indeterminate !== undefined) {
      inputRef.current.indeterminate = indeterminate;
    }
  }, [indeterminate]);
  var Wrapper = label ? Container : FragmentWithoutProps;
  return /*#__PURE__*/jsxs(Wrapper, {
    $size: $size,
    children: [/*#__PURE__*/jsxs(InputContainer, {
      $hasLabel: label !== undefined,
      $size: $size,
      children: [/*#__PURE__*/jsx(Input, _extends({}, restProps, {
        type: "checkbox",
        id: id,
        ref: ref,
        required: required,
        $invalid: invalid
      })), /*#__PURE__*/jsx(StyledOverlay, {
        $invalid: invalid,
        children: indeterminate ? minusIconMap.get($size) : checkIconMap.get($size)
      })]
    }), label && /*#__PURE__*/jsx(Label, {
      htmlFor: id,
      children: label
    })]
  });
});

export { Checkbox };
